import React from 'react';

/**
 * Icons for the share sheet.
 *
 * Official platform icons live in public/icons/social/{id}.png (128x128,
 * trimmed and centered on a transparent square; source files are in
 * public/icons/social/originals/). Platforms listed here render their icon
 * on a white tile; anything else falls back to a brand-colored monogram.
 * To add one: save {id}.png there and add the id below.
 */
export const OFFICIAL_ICON_IDS = new Set([
  'instagram', 'tiktok', 'facebook', 'x', 'linkedin', 'threads',
  'bluesky', 'reddit', 'whatsapp', 'substack', 'slack',
]);

export const hasOfficialIcon = (platform) => OFFICIAL_ICON_IDS.has(platform.id);

const stroke = {
  fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round',
};

// Generic (non-brand) glyphs
const GLYPHS = {
  email: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" {...stroke} />
      <path d="M3.5 6.5 12 13l8.5-6.5" {...stroke} />
    </>
  ),
  messages: (
    <path d="M4 5h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H9l-5 4v-4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z" {...stroke} />
  ),
  more: (
    <>
      <path d="M12 3v12" {...stroke} />
      <path d="m7 8 5-5 5 5" {...stroke} />
      <path d="M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6" {...stroke} />
    </>
  ),
  link: (
    <>
      <path d="M10 14a4 4 0 0 0 5.66 0l3-3a4 4 0 0 0-5.66-5.66l-1 1" {...stroke} />
      <path d="M14 10a4 4 0 0 0-5.66 0l-3 3a4 4 0 0 0 5.66 5.66l1-1" {...stroke} />
    </>
  ),
  copy: (
    <>
      <rect x="8" y="8" width="12" height="12" rx="2" {...stroke} />
      <path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" {...stroke} />
    </>
  ),
  download: (
    <>
      <path d="M12 4v11" {...stroke} />
      <path d="m7 10 5 5 5-5" {...stroke} />
      <path d="M5 20h14" {...stroke} />
    </>
  ),
};

export const Glyph = ({ name, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    {GLYPHS[name]}
  </svg>
);

/** Content for a platform tile: official SVG, generic glyph, or monogram. */
export const PlatformMark = ({ platform, size = 26 }) => {
  if (hasOfficialIcon(platform)) {
    return <img src={`/icons/social/${platform.id}.png`} alt="" width={36} height={36} style={{ display: 'block' }} />;
  }
  if (platform.icon && GLYPHS[platform.icon]) {
    return <Glyph name={platform.icon} size={size} />;
  }
  return (
    <span style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700, fontSize: platform.monogram.length > 1 ? 17 : 22, letterSpacing: '-0.02em' }}>
      {platform.monogram}
    </span>
  );
};
